import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import learningStudentsImage from "../../assets/images/login/learning-students.png";
import { LOGIN_USER_API, NEW_USER_API } from "../../services/apiConstants";
import "./Home.css";

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSignup, setShowSignup] = useState(false);
  const [signupError, setSignupError] = useState("");
  const [signupLoading, setSignupLoading] = useState(false);

  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: ""
  });

  const handleSignup = async () => {
    const { firstName, lastName, email, password, confirmPassword } = signupData;
    setSignupError("");
    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      alert("Please fill all mandatory fields");
      setSignupError("All mandatory fields must be filled");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      setSignupError("Passwords do not match");
      return;
    }
    setSignupLoading(true);
    try {
      // 🔗 connect backend later
      console.log("Signup Data:", signupData);
      const createResponse = await axios.post(NEW_USER_API, {
        firstName,
        lastName,
        email,
        password,
        phone: signupData.phone
      },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      alert("Account created successfully!");
      setShowSignup(false); // close popup
      setSignupData({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: ""
      });

    } catch (error) {
        alert(error.response?.data?.message || "Registration failed");
}
    finally {
      setSignupLoading(false);
    }
  };
  // Get user JSON passed from Home

  // 👉 Navigate to Mock Exam List
  const goToMockExams = () => {
    navigate("/MockExamList"); // must match App.js route
  };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // 👉 Login → Java Spring Boot service
  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter email and password");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(LOGIN_USER_API,
        { email, password }
      );
      const user = response.data;
      const token = response.headers["authorization"];
     
      if (token) {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token",token);
        sessionStorage.setItem("activeSession", "true");
      }
      navigate(location.state?.returnTo || "/Dashboard");

    } catch (err) {
      alert("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };
  
  const handleSignupChange = (e) => {
    const { name, value } = e.target;

    setSignupData((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  return (
    <>
      <div className="home-container">
        {/* LEFT SIDE */}
        <div className="home-left">
          <h2>Empowering Developers & Businesses with Smarter Tech</h2>
          <p>
            At InventraLabs, we deliver skill-based <strong>mock exams</strong>,
            intelligent <strong>assessment tools</strong>, and innovative{" "}
            <strong>software solutions</strong> to help developers sharpen skills
            and businesses hire top talent efficiently.
          </p>

          <div className="learning-image-panel">
            <img
              src={learningStudentsImage}
              alt="Students learning together"
            />
          </div>

          <div className="hero-buttons">
            <button className="primary-btn" onClick={goToMockExams}>
              Explore Mock Exams
            </button>
            <button className="secondary-btn">
              Learn About Products
            </button>
          </div>
        </div>

        {/* RIGHT SIDE – Login */}
        <div className="home-right">
          <div className="login-card">
            <h2>Welcome Back</h2>
            <p>Login to continue your journey</p>

            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />

            <button
              className="login-btn"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            <p className="or">— OR —</p>

            <button className="google-btn">
              Continue with Google
            </button>
            <p className="signup-link">
              New to InventraLabs?{" "}
              <span
                style={{ cursor: "pointer", color: "#4f46e5" }}
                onClick={() => setShowSignup(true)}
              >
                Create an account
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* SIGNUP MODAL */}
      {showSignup && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Create Account</h2>
            <input
              name="firstName"
              placeholder="First Name *"
              value={signupData.firstName}
              onChange={handleSignupChange}
            />

            <input
              name="lastName"
              placeholder="Last Name *"
              value={signupData.lastName}
              onChange={handleSignupChange}
            />

            <input
              name="email"
              type="email"
              placeholder="Email *"
              value={signupData.email}
              onChange={handleSignupChange}
            />

            <input
              name="password"
              type="password"
              placeholder="Password *"
              value={signupData.password}
              onChange={handleSignupChange}
            />

            <input
              name="confirmPassword"
              type="password"
              placeholder="Re-type Password *"
              value={signupData.confirmPassword}
              onChange={handleSignupChange}
            />

            <input
              name="phone"
              placeholder="Phone (optional)"
              value={signupData.phone}
              onChange={handleSignupChange}
            />

            <div className="modal-actions">
              <button onClick={handleSignup} disabled={signupLoading}>
                {signupLoading ? "Creating..." : "Create Account"}
              </button>
              <button
                className="cancel"
                onClick={() => setShowSignup(false)}
                disabled={signupLoading}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>

      )}

    </>
  );
}
export default Home;
